import { Fare } from '@/src/types/itinerary'
import { isNxItineraryId } from '@/src/utils/itinerary/isNxItineraryId'

/** Resolves fare brand for SMB mandatory map keys (NX/NIX: map; NI: fareGroupInformation). */
export const getFareCtBrandName = (fare?: Fare | null, itineraryId?: string): string => {
    if (itineraryId && isNxItineraryId(itineraryId)) {
        const fareGroupInformationMap = fare?.fareGroupInformationMap
        const firstFareGroup =
            fareGroupInformationMap?.['1'] ?? Object.values(fareGroupInformationMap ?? {})[0]
        return firstFareGroup?.ctBrandName ?? 'REGULAR'
    }

    return fare?.fareGroupInformation?.ctBrandName ?? 'REGULAR'
}
